// /shared-types/api-types/src/schemas/resetPasswordSchemas.ts
import { z } from 'zod';
export const forgotPasswordSchema = z.object({
    email: z.string()
        .email('Invalid email format')
        .min(1, 'Email is required')
});
export const resetPasswordSchema = z.object({
    token: z.string()
        .min(1, 'Reset token is required'),
    newPassword: z.string()
        .min(6, 'Password must be at least 6 characters long')
        .max(128, 'Password is too long')
});
export const verifyResetTokenParamsSchema = z.object({
    token: z.string()
        .min(1, 'Token is required')
});
//# sourceMappingURL=ResetPassword.js.map